var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import { offerListExchangeRate as api } from '../../../api';
import TextField from '../../atoms/TextFieldNew';
import { useRequest } from '../../../hooks/requestHook';
import useDirectlyUpdatableTextField from '../../../hooks/hoc/useDirectlyUpdatableTextField';
import { useNotify } from '../../../hooks/notificationHook';
import { useConfirm } from '../../../hooks/confirmationHook';
var OfferListExchangeRates = function (_a) {
    var offerList = _a.offerList;
    var t = useTranslation().t;
    var getExchangeRates = useRequest(api.getAll);
    var setExchangeRate = useRequest(api.set);
    var notify = useNotify();
    var confirm = useConfirm();
    var _b = React.useState([]), exchangeRates = _b[0], setExchangeRates = _b[1];
    var DirectUpdateTextField = useDirectlyUpdatableTextField(TextField);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getExchangeRates(offerList.id)];
                    case 1:
                        response = _a.sent();
                        if (!response || canceled)
                            return [2 /*return*/];
                        setExchangeRates(sortExchangeRates(response));
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [offerList, getExchangeRates]);
    var confirmRate = React.useCallback(function (rate, currency, callback) {
        var warnings = [];
        var willUpdateRate = exchangeRates.find(function (rate) { return rate.currency === currency; });
        if ((willUpdateRate === null || willUpdateRate === void 0 ? void 0 : willUpdateRate.highestRate) &&
            parseFloat(willUpdateRate.highestRate) < parseFloat(rate)) {
            warnings.push(t('messages.exchangeRateMoreThanHighestRateOnPrevMonth', {
                rate: willUpdateRate.highestRate,
            }));
        }
        if ((willUpdateRate === null || willUpdateRate === void 0 ? void 0 : willUpdateRate.lowestRate) &&
            parseFloat(willUpdateRate.lowestRate) > parseFloat(rate)) {
            warnings.push(t('messages.exchangeRateLessThanLowestRateOnPrevMonth', {
                rate: willUpdateRate.lowestRate,
            }));
        }
        if (warnings.length === 0) {
            callback();
            return;
        }
        confirm('', React.createElement(React.Fragment, null, warnings.map(function (warning, index) { return (React.createElement("div", { key: index }, warning)); })), callback);
    }, [confirm, exchangeRates, t]);
    var updateExchangeRate = React.useCallback(function (rate, currency) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            confirmRate(rate, currency, function () { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, setExchangeRate({
                                offerListId: offerList.id,
                                currency: currency,
                                rate: rate,
                            })];
                        case 1:
                            response = _a.sent();
                            if (!response)
                                return [2 /*return*/];
                            setExchangeRates([]); // clear textfield component
                            setExchangeRates(sortExchangeRates(response));
                            notify('success', [t('messages.updateSuccess')]);
                            return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); }, [offerList, setExchangeRate, t, notify, confirmRate]);
    var disabled = !['draft', 'preparing'].includes(offerList.status);
    return (React.createElement(Grid, { container: true, spacing: 1 },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { variant: "h6" }, t('pages.exchangeRates.title'))),
        exchangeRates.map(function (_a) {
            var rate = _a.rate, currency = _a.currency;
            return (React.createElement(Grid, { key: currency, item: true, xs: 12, sm: 6, md: 3 },
                React.createElement(DirectUpdateTextField, { fullWidth: true, type: "number", margin: "normal", label: t('pages.exchangeRates.exchangeRateColumnTitle', {
                        currency: currency,
                    }), name: currency, value: rate, onUpdate: updateExchangeRate, disabled: disabled })));
        })));
};
export default OfferListExchangeRates;
var sortExchangeRates = function (exchangeRates) {
    return exchangeRates.sort(function (a, b) { return a.currency.localeCompare(b.currency); });
};
